import { format } from 'date-fns'

export const validDate = (date: Date, dateFormat: string) => {
  try {
    return format(new Date(date), dateFormat)
  } catch (error) {
    return format(new Date(date), 'yyyy-MM-dd')
  }
}
